// Must match MEMORY_SUGGESTION_READY_EVENT in apps/api/apps/api/src/resources/ai-agent-v2/constants/agent-memory.constants.ts.
export const EVENT_MEMORY_SUGGESTION_READY = "memory-suggestion-ready";
export const EVENT_MSG_CHECKLIST_APPLICATION_UPDATED = "checklist.application.updated";
export const EVENT_MSG_TASK_CHANGED = "task.changed";
export const EVENT_MSG_WORKFLOW_CHANGED = "workflow.changed";
export const EVENT_MSG_FILE_CHANGED = "file.changed";
// Must match THREAD_NAMED_EVENT in apps/api/libs/resources/src/threads/threads.constants.ts.
export const EVENT_THREAD_NAMED = "thread.named";
export const EVENT_USER_ROLE_REMOVED = "user.role-removed";
export const EVENT_MSG_ROLE_MEMBERSHIP_CHANGED = "role.membership-changed";
